export default __webpack_public_path__ + "static/step2-31d180adb263096405813bfef415c18d.png";